<template>
    <vs-table :data="listStudents">
        <template slot="thead">
            <vs-th style="width: 50px;">№</vs-th>
            <vs-th>{{ $t("student") }}</vs-th>
            <vs-th style="width: 50px; padding: 10px 5px;">{{ $t("student_id") }}</vs-th>
            <vs-th style="width: 50px; padding: 10px 5px;">{{ $t("chosen_as") }}</vs-th>
            <vs-th>{{ $t("Emails") }}</vs-th>
            <vs-th>{{ $t("education_level") }}</vs-th>
            <vs-th style="width: 25px; padding: 10px 5px;">{{ $t("course") }}</vs-th>
            <vs-th>{{ $t("direction") }}</vs-th>
            <vs-th>{{ $t("study__card") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
            <vs-tr :key="index" v-for="(tr, index) in listStudents">
                <vs-td>
                    {{index+1}}
                </vs-td>
                <div class="text-primary cursor" @click="goToProfile(data[index])">
                    <vs-td :data="data[index].student">
                        {{ data[index].student.last_name }}
                        {{ data[index].student.first_name }}
                        {{ data[index].student.middle_name }}
                    </vs-td>
                </div>
                <vs-td :data="data[index].student.student_id" style="width: 50px; padding: 10px 5px;">
                    {{ data[index].student.student_id }}
                </vs-td>
                <vs-td :data="data[index].student.student_id" style="width: 50px; padding: 10px 5px;">
                    <div v-if="data[index].audit && !data[index].queue">
                        {{ $t('audit') }}
                    </div>
                    <div v-else-if="!data[index].audit && !data[index].queue">
                        {{ $t('credit') }}
                    </div>
                    <div v-else-if="data[index].queue">
                        {{ $t('waiting_list') }}
                    </div>
                </vs-td>

                <vs-td :data="data[index].student.emails">
                    {{ data[index].student.emails }}
                </vs-td>

                <vs-td v-if="data[index].study_plan.preparation_level" :data="data[index].study_plan.preparation_level.name">
                    {{ data[index].study_plan.preparation_level.name }}
                </vs-td>

                <vs-td :data="data[index].study_plan.course" style="width: 25px; padding: 10px 5px;">
                    {{ data[index].study_plan.course }}
                </vs-td>
                <vs-td v-if="data[index].study_plan.education_program" :data="data[index].study_plan.education_program.name">
                    {{ data[index].study_plan.education_program.code }} - {{ data[index].study_plan.group.name }}
                </vs-td>
                <vs-td :data="data[index].status">
                    {{ data[index].status.name }}
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>
</template>

<script>
export default {
    name: "StudentsTable",
    props:{
        listStudents:{
            type: Array,
        }
    },
    methods:{
        goToProfile(item){
            this.$emit('goToProfile', item)
        }
    }
};
</script>

<style scoped>

</style>
